<div class="k-pos-relative">
  <kendo-multiselect
    #multiSelectComponent
    [autoClose]="false"
    [allowCustom]="true"
    [filterable]="true"
    [valueNormalizer]="valueNormalizer"
    [id]="'tags'"
    (valueChange)="change($event)"
    (removeTag)="removeTag($event)"
    (filterChange)="handleFilter($event)"
    [data]="unselectedTags()"
    (opened)="opened()"
    (closed)="closed()"
    [loading]="loading()"
    [value]="selectedTags()"
    textField="name"
    valueField="id"
  >
    <ng-template kendoMultiSelectCustomItemTemplate>
      <span style="display: none"></span>
    </ng-template>
    <ng-template kendoPrefixTemplate>
      <fa-icon class="px-2" [icon]="faTag" />
    </ng-template>
    <ng-template kendoMultiSelectTagTemplate let-tag>
      <span style="color: #fff">{{ tag.name }}</span>
    </ng-template>
    <ng-template kendoMultiSelectItemTemplate let-tag>
      <div class="k-d-flex k-justify-content-between">
        <span>{{ tag.name }}</span>
        <div class="controls k-display-flex">
          <fa-icon
            role="button"
            class="turquoise k-display-flex k-align-items-stretch k-ml-1.5 k-px-1.5"
            [icon]="faEdit"
            (click)="openDialog(tag)"
          ></fa-icon>
          <fa-icon
            role="button"
            class="trash red k-display-flex k-align-items-stretch k-ml-1.5 k-px-1.5"
            [icon]="faTrash"
            (click)="deleteTag(tag, $event)"
          ></fa-icon>
        </div>
      </div>
    </ng-template>
  </kendo-multiselect>
</div>
